<svg width="509" height="846" viewBox="0 0 509 846" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="65" cy="65" r="65" transform="matrix(-0.983893 -0.178758 -0.178758 0.983893 263.145 587.238)" fill="url(#paint0_linear_42_513)"/>
    <circle cx="29" cy="29" r="29" transform="matrix(-0.983893 -0.178758 -0.178758 0.983893 117.434 543.368)" fill="url(#paint1_linear_42_513)"/>
    <circle cx="20.5818" cy="20.5818" r="20.5818" transform="matrix(-0.983893 -0.178758 -0.178758 0.983893 188.408 156.21)" fill="url(#paint2_linear_42_513)"/>
    <circle cx="20.5818" cy="20.5818" r="20.5818" transform="matrix(-0.983893 -0.178758 -0.178758 0.983893 178.382 452.199)" fill="url(#paint3_linear_42_513)"/>
    <circle cx="289.5" cy="289.5" r="289.5" transform="matrix(0.961067 0.276315 0.276315 -0.961067 118.934 581.928)" fill="url(#paint4_linear_42_513)"/>
    <defs>
    <linearGradient id="paint0_linear_42_513" x1="65" y1="130" x2="338.509" y2="-224.292" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint1_linear_42_513" x1="29" y1="58" x2="-46.2018" y2="-52.9011" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint2_linear_42_513" x1="20.5817" y1="41.1635" x2="-32.7901" y2="-37.5447" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint3_linear_42_513" x1="20.5817" y1="41.1635" x2="-32.7901" y2="-37.5447" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint4_linear_42_513" x1="105" y1="90" x2="683" y2="707" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    </defs>
</svg>
    